module.exports = __webpack_public_path__ + "static/media/pic4.27034a5e.png";